var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1832 26.0072C62.0051 25.4827 61.6773 25.0217 61.2402 24.6814C60.8032 24.341 60.276 24.1361 59.7238 24.0919L43.571 22.8084L36.5812 7.33554C36.3586 6.83719 35.9965 6.41392 35.5386 6.1168C35.0808 5.81969 34.5467 5.66143 34.0009 5.66113C33.4551 5.66083 32.9209 5.8185 32.4627 6.11512C32.0045 6.41173 31.642 6.8346 31.4188 7.33271L24.429 22.8084L8.27617 24.0919C7.73346 24.1349 7.21462 24.3333 6.78174 24.6634C6.34885 24.9936 6.02025 25.4415 5.83523 25.9535C5.65021 26.4655 5.61662 27.0199 5.73848 27.5505C5.86033 28.0811 6.13247 28.5654 6.52233 28.9454L18.4592 40.5819L14.2375 58.8625C14.1093 59.4159 14.1504 59.995 14.3554 60.5247C14.5604 61.0544 14.9199 61.5103 15.3873 61.8331C15.8546 62.156 16.4082 62.3309 16.9762 62.3352C17.5441 62.3396 18.1003 62.1731 18.5725 61.8574L34 51.5724L49.4275 61.8574C49.9101 62.1778 50.4793 62.3428 51.0585 62.3301C51.6376 62.3174 52.199 62.1276 52.6671 61.7863C53.1352 61.445 53.4876 60.9686 53.6768 60.4211C53.8661 59.8736 53.8831 59.2812 53.7257 58.7237L48.5435 40.5904L61.3955 29.0247C62.237 28.2654 62.5458 27.081 62.1832 26.0072Z",
    fill: "#EFA92B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6b633d0dd1623a5cc156d18b07cf4637.svg";
export { ForwardRef as ReactComponent };